export default __webpack_public_path__ + "static/media/business_one.03a4eb45.png";